import { JobSecurityRight } from '../../modules/job.security.module';
import { SecurityRoleTiny } from '../../security.role';
import { SecurityRoleUtility } from '../../utility/security.roles.utility';

export function jobSecurityHasRight(role: SecurityRoleTiny, ...rights: JobSecurityRight[]): boolean {

    return SecurityRoleUtility.checkTinyRights(role, ...rights);
}
